/**
 * 圖片模板樣式 - 全新極簡設計
 * 
 * 設計理念：
 * 1. 移除複雜的卡片、邊框、圖案
 * 2. 使用純色背景 + 微妙漸層
 * 3. 專注於顏色和字體
 * 4. 每個模板只定義：主背景色、強調色、文字色
 */

export const IMAGE_TEMPLATES = {
  // 原始風格 - 粉紅經典
  original: {
    id: 'original',
    nameZh: '粉紅經典',
    nameEn: 'Pink Classic',
    emoji: '💖',
    gradient: 'from-love-400 to-love-600',
    description: {
      zh: '溫柔粉紅色調',
      en: 'Soft Pink Tone'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)',
      accent: '#ec4899',
      text: '#be185d',
      textSecondary: '#db2777'
    }
  },

  y2k: {
    id: 'y2k',
    nameZh: 'Y2K 賽博',
    nameEn: 'Y2K Cyber',
    emoji: '💕',
    gradient: 'from-purple-400 via-pink-500 to-purple-600',
    description: {
      zh: '千禧年風格',
      en: 'Cyber Style'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      accent: '#ff00ff',
      text: '#ffffff',
      textSecondary: '#e0e0ff'
    }
  },

  polaroid: {
    id: 'polaroid',
    nameZh: '寶麗來',
    nameEn: 'Polaroid',
    emoji: '📷',
    gradient: 'from-amber-100 to-amber-200',
    description: {
      zh: '復古膠片',
      en: 'Vintage Film'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #f5e6d3 0%, #d4b5a0 100%)',
      accent: '#8b4513',
      text: '#3e2723',
      textSecondary: '#5d4037'
    }
  },

  glass: {
    id: 'glass',
    nameZh: '玻璃藍',
    nameEn: 'Glass Blue',
    emoji: '💎',
    gradient: 'from-blue-400 to-blue-600',
    description: {
      zh: '清透藍色',
      en: 'Clear Blue'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
      accent: '#60a5fa',
      text: '#ffffff',
      textSecondary: '#bfdbfe'
    }
  },

  neon: {
    id: 'neon',
    nameZh: '霓虹夜',
    nameEn: 'Neon Night',
    emoji: '✨',
    gradient: 'from-gray-900 via-pink-900 to-cyan-900',
    description: {
      zh: '賽博朋克',
      en: 'Cyberpunk'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 100%)',
      accent: '#ff006e',
      text: '#ffffff',
      textSecondary: '#00f5ff'
    }
  },

  gradient: {
    id: 'gradient',
    nameZh: '彩虹流',
    nameEn: 'Rainbow Flow',
    emoji: '🌈',
    gradient: 'from-pink-400 via-yellow-400 to-cyan-400',
    description: {
      zh: '繽紛漸層',
      en: 'Colorful Gradient'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #fa709a 0%, #fee140 50%, #30cfd0 100%)',
      accent: '#fa709a',
      text: '#ffffff',
      textSecondary: '#fff5e1'
    }
  },

  paper: {
    id: 'paper',
    nameZh: '紙張米',
    nameEn: 'Paper Beige',
    emoji: '📄',
    gradient: 'from-yellow-100 to-orange-200',
    description: {
      zh: '溫暖米色',
      en: 'Warm Beige'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%)',
      accent: '#fd79a8',
      text: '#2d3436',
      textSecondary: '#636e72'
    }
  },

  holo: {
    id: 'holo',
    nameZh: '全息彩',
    nameEn: 'Holographic',
    emoji: '💿',
    gradient: 'from-purple-400 via-pink-400 to-blue-400',
    description: {
      zh: '彩虹光澤',
      en: 'Rainbow Shine'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      accent: '#f093fb',
      text: '#ffffff',
      textSecondary: '#e0e0ff'
    }
  },

  watercolor: {
    id: 'watercolor',
    nameZh: '水彩粉',
    nameEn: 'Watercolor',
    emoji: '🎨',
    gradient: 'from-pink-200 via-rose-200 to-red-200',
    description: {
      zh: '柔和暈染',
      en: 'Soft Paint'
    },
    colors: {
      mainBg: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 50%, #ff9a9e 100%)',
      accent: '#ff6b9d',
      text: '#2d3436',
      textSecondary: '#636e72'
    }
  }
};

/**
 * Get template by ID
 */
export const getTemplate = (templateId) => {
  return IMAGE_TEMPLATES[templateId] || IMAGE_TEMPLATES.original;
};

/**
 * Get all template IDs
 */
export const getTemplateIds = () => {
  return Object.keys(IMAGE_TEMPLATES);
};